module.exports = __webpack_public_path__ + "static/media/landing-hero.52b756cf.jpg";